import React from 'react';
import ReactDOM from 'react-dom/client';
import "./global.css";
import App from './App';
import { PrimeReactProvider} from 'primereact/api';
import PersistentTimer from "./components/PersistentTimer";
import { TimerProvider } from './context/TimerContext';
import { AuthProvider } from './config/authContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <PrimeReactProvider>
        <AuthProvider>
            <TimerProvider>
                <PersistentTimer />
                <App />
            </TimerProvider>
        </AuthProvider>
    </PrimeReactProvider>
)

